import { Box, MenuItem } from '@mui/material'
import type { ReactNode } from 'react'

export interface OptionItem<T> {
  value: T
  label: string
  icon: ReactNode
  isDelete?: boolean
}

export interface OptionsPopoverItemsProps<T> {
  options: OptionItem<T>[]
  onItemSelected: (item: T) => void
}

export function OptionsPopoverItems<T>({ options, onItemSelected }: OptionsPopoverItemsProps<T>) {
  return (
    <>
      {options.map((opt, i) => (
        <MenuItem
          key={i}
          onClick={() => onItemSelected(opt.value)}
          sx={opt.isDelete ? { color: 'error.main', width: '100%' } : { width: '100%' }}
        >
          <Box sx={{ display: 'flex', mr: 0.75 }}>{opt.icon}</Box>
          {opt.label}
        </MenuItem>
      ))}
    </>
  )
}
